import { alpha } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    margin: theme.spacing(-2, 0, 7.51, 0),
  },
  label: {
    background: alpha(theme.palette.button.secondary, 0.35),
    borderRadius: theme.spacing(12.5),
    padding: theme.spacing(1),
    fontWeight: 400,
    lineHeight: '16px',
    fontSize: theme.spacing(1.5),
  },

  tabs: {
    background: theme.palette.background.paper,
  },
  tab: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0, 2),
    gap: theme.spacing(0.5),
  },
  detailsContainer: {
    marginTop: theme.spacing(4),
  },
  contractsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  emptyStateContainer: {
    background: theme.palette.common.white,
    borderRadius: theme.spacing(1),
  },
}))
